// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__sEMwD","header":"ClearentDisclaimer_header__21uKq","inner":"ClearentDisclaimer_inner__MIaqL"};